import DataGridTable from '@/common/components/DataGridTable/DataGridTable';

export default DataGridTable;
